import { action, observable } from 'mobx';
import type { RootStore } from './root.store';

export class UploadPdfStore {
    rootStore: RootStore = null;

    @observable variable: boolean = false;

    constructor(rootStore: RootStore) {
        this.rootStore = rootStore;
    }

    @action.bound
    setVariable(variable: boolean) {
        this.variable = variable;
    }
}
